import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { JournalTaxTypeEnum } from '../../../types/journal';
import { Link } from 'react-router-dom';
import { WorksheetWithAccount } from '../../../types/worksheet';
import { useFirmContext } from '../../../providers/FirmProvider';
import AccountSelect from '../../../components/account-select/AccountSelect';
import { WorksheetStatusIcon } from '../../worksheet-v2/WorksheetStatusIcon';
import { AccountClassification, EntityAccount } from '../../../types/entity';

type AccountFieldProps = {
    index: number;
    amountEditable: boolean;
    accounts?: EntityAccount[];
    worksheet?: WorksheetWithAccount;
    onAccountChange: (acc?: AccountClassification) => void;
    onPopulate: () => void;
};

function AccountField({ index, amountEditable, accounts, worksheet, onAccountChange, onPopulate }: AccountFieldProps): JSX.Element {
    const { control } = useFormContext();
    const { shortId } = useFirmContext();

    const taxType = useWatch({ control, name: `taxType` });

    function handleAccountSelect(value: EntityAccount[]): void {
        onAccountChange(value[0]?.class ? (value[0].class as AccountClassification) : undefined);
        if (!taxType || taxType === JournalTaxTypeEnum.NO_TAX) {
            onPopulate();
        }
    }

    return (
        <>
            {amountEditable && (
                <Controller
                    name={`lines.${index}.account`}
                    control={control}
                    render={({ field: { onChange, value } }): JSX.Element => (
                        <AccountSelect
                            placeholder="Account..."
                            size="small"
                            selectedAccounts={value === null ? [] : accounts?.filter((acc) => acc.id === value)}
                            onChange={(val): void => {
                                onChange(val[0]?.id || null);
                                handleAccountSelect(val);
                            }}
                        />
                    )}
                />
            )}
            {!amountEditable && worksheet && (
                <div className="flex gap-2 items-center">
                    <WorksheetStatusIcon status={worksheet.status} smallIcon />
                    <Link to={`/${shortId}/workpapers/${worksheet.workpaperId}/trial-balance/${worksheet.id}?tab=journals`}>
                        <div className="text-indigo-600 text-xs font-medium">{worksheet.name}</div>
                    </Link>
                </div>
            )}
        </>
    );
}

export default AccountField;
